import * as yup from "yup";
import { QUEUEID } from "./queue-id-constants";

export interface FormData {
  name: string;
  phoneNumber: string;
  email: string;
  isMember: "" | "Ja" | "Nej";
}

yup.setLocale({
  mixed: {
    required: "Dette felt er obligatorisk",
  },
  string: {
    email: "Denne email ser forkert ud",
  },
});

export const validationSchema = () => {
  return yup.object().shape({
    name: yup.string().required(),
    phoneNumber: yup.string().required(),
    email: yup.string().email().required(),
    isMember: yup.string().required(),
  });
};

export const to = (body: any) => {
  if (body.subject === QUEUEID.SundhedsForsikring) {
    return "sundhed-info@gjensidige.dk";
  }
};

export default validationSchema;
